import { PaginationRow } from '../../Pages/FuelSurchargeContainer/components';

interface Props {
  headers: {
    key: string;
    text: string | any;
    getCellContent: (value: any) => any;
    noWrap?: boolean;
  }[];
  data: { [key: string]: any }[];
  loading: boolean;
  page?: number;
  onChangePage?: (page: number) => void;
  pageSize?: number;
  onChangePageSize?: (size: number) => void;
  count?: number;
  pages?: number;
  hasPagination?: boolean;
  noWrap?: boolean;
}

export default function DataTable({
  data,
  headers,
  loading,
  page,
  onChangePage,
  pageSize,
  onChangePageSize,
  count,
  pages,
  hasPagination = true,
  noWrap = false,
}: Props) {
  const pageSizeOptions = [25, 50, 75, 100, 125];

  return (
    <div
      className='DataTable'
      style={{
        overflow: 'scroll',
      }}
    >
      <div
        style={{
          minWidth: '100%',
          width: 'fit-content',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'end',
        }}
      >
        <table className='table ' id='shipment_table'>
          <thead className='ubbe-table-header'>
            <tr>
              {headers.map(({ text }, i) => (
                <th className='ubbe-table-heading-text' key={i}>
                  {text}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr className='text-center'>
                <td colSpan={9}>
                  <div className='spinner-border' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                  </div>
                </td>
              </tr>
            ) : !!data && data.length > 0 ? (
              data.map((datum, i) => (
                <tr key={i}>
                  {headers.map(({ key, getCellContent, noWrap }, j) => (
                    <td
                      className='align-middle'
                      key={j}
                      style={{ whiteSpace: noWrap ? 'nowrap' : undefined }}
                    >
                      {getCellContent(datum?.[key])}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr className='NoRecords'>
                <td
                  colSpan={headers.length}
                  className='text-center global-text align-middle'
                  style={{ color: ' #979797' }}
                >
                  No records found! Please try again.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {pageSize !== undefined &&
          onChangePageSize !== undefined &&
          !!pages &&
          hasPagination && (
            <div
              style={{
                width: '100%',
              }}
            >
              <PaginationRow
                pageSizeOptions={pageSizeOptions}
                pageSize={pageSize}
                setPageSize={onChangePageSize}
                currentSize={pageSize}
                currentPage={page}
                setCurrentPage={onChangePage}
                totalItems={count}
                totalPages={pages}
              />
            </div>
          )}
      </div>
    </div>
  );
}
